import React from 'react';
import RenderInput from "../TrafficSource/RenderInput";
import {getFieldLabelsForCategory, signatureBlockFilterFields} from "../../utils/signatureBlockUtils";

const SignatureBlockRenderInputs = ({ fieldType, editProps, data, disabled = false, defaultCategory }) => {

    const fieldLabels = getFieldLabelsForCategory(defaultCategory)
    const filterFields = data.allFilterFields.enumValues.filter(item => signatureBlockFilterFields.includes(item.name))
    switch (fieldType) {
        case 'filterField':
            return (
                <RenderInput
                    item={{
                        label: "Filter Field",
                        key: "filterField",
                        type: "autoComplete",
                        required: true,
                        options: defaultCategory || filterFields,
                        returnKey: 'name',
                        displayKey: 'name'
                    }}
                    disabled={disabled}
                    value={editProps.value || ''}
                    data={data}
                    handleFilterChange={value => {
                        editProps.onChange(value);
                    }}
                />
            );
        case 'blockReason':
            return (
                <RenderInput
                    item={{
                        label: "Block Reason",
                        key: "blockReason",
                        type: "autoComplete",
                        required: true,
                        val: 'allBlockReasons',
                        returnKey: 'name',
                        displayKey: 'name'
                    }}
                    disabled={disabled}
                    value={editProps.value || ''}
                    data={data}
                    handleFilterChange={value => {
                        editProps.onChange(value);
                    }}
                />
            );
        case 'signatureBlockSource':
            return (
                <RenderInput
                    item={{
                        label: "Signature Block Source",
                        key: "signatureBlockSource",
                        type: "autoComplete",
                        required: false,
                        val: 'ADMIN_ENTERED',
                        returnKey: 'name',
                        displayKey: 'name'
                    }}
                    disabled={disabled}
                    value={'ADMIN_ENTERED'}
                    data={data}
                    handleFilterChange={value => {
                        editProps.onChange(value);
                    }}
                />
            );
        case 'expires':
            return (
                <RenderInput
                    item={{
                        label: "Expires",
                        key: "expires",
                        type: "dateTime",
                        required: false,
                        returnKey: 'expires',
                        displayKey: 'expires'
                    }}
                    disabled={disabled}
                    value={editProps.value || null}
                    data={data}
                    handleFilterChange={value => {
                        editProps.onChange(value);
                    }}
                />
            );
        case 'firstBlockValue':
            return (
                <RenderInput
                    item={{
                        label: fieldLabels.first,
                        key: 'firstBlockValue',
                        type: 'text',
                        required: true
                    }}
                    value={editProps.value || ''}
                    data={data}
                    disabled={false}
                    handleInputChange={e => editProps.onChange(e.target.value)}
                />
            );
        case 'secondBlockValue':
            return (
                <RenderInput
                    item={{
                        label: fieldLabels.second,
                        key: 'secondBlockValue',
                        type: 'text',
                        required: true
                    }}
                    value={editProps.value || ''}
                    data={data}
                    disabled={disabled}
                    handleInputChange={e => editProps.onChange(e.target.value)}
                />
            );
        case 'overrideExisting':
            return (
                <RenderInput
                    item={{
                        label: "Override Existing",
                        key: 'overrideExisting',
                        type: 'switch',
                        required: true
                    }}
                    value={editProps.value || false}
                    data={data}
                    disabled={disabled}
                    handleSwitchChange={e => editProps.onChange(e.target.checked)}
                />
            );
        default:
            return (
                <RenderInput
                    item={{
                        label: fieldLabels.first,
                        key: 'blockValue',
                        type: 'text',
                        required: true
                    }}
                    value={editProps.value || ''}
                    data={data}
                    disabled={false}
                    handleInputChange={e => editProps.onChange(e.target.value)}
                />
            );
    }
};

export default SignatureBlockRenderInputs;
